// @flow
import * as React from "react";
import { page } from "../../components/Auth/Page";

export const TapCreateProfilePage = page(
  React.lazy(() => import("./containers/CreateProfilePage")),
);
